import hannahIllustration from '../static/images/sectionTalking/2014/hannah-illustration.png';
import hannahPhoto from '../static/images/sectionTalking/2014/hannah.png';
import eddieIllustration from '../static/images/sectionTalking/2014/eddie-illustration.png';
import eddiePhoto from '../static/images/sectionTalking/2014/eddie.png';
import ericIllustration from '../static/images/sectionTalking/2014/eric-illustration.png';
import ericPhoto from '../static/images/sectionTalking/2014/eric.png';

export default [
    {
        name: "HANNAH",
        position: "Front-End Developer",
        img: hannahIllustration,
        photo: hannahPhoto,
        article: `<p>嗨，我是新芽第一個實習生 Hannah，目前是正職的Front End Designer</p>
                <p>第一次看到新芽在網站上放的辦公室照片跟簡介，半夜一邊滑手機，一邊欲罷不能的看了幽默的同事們寫的 blog，躲在被窩裡ㄎㄎ笑後，就覺得「啊！要是能進入這樣的公司就好了！」能進入這麼有活力有對工作充滿熱情的公司，一定會很棒吧。</p>
                <p>說起來滿幸運的，認識 25sprout 沒過幾天就得知公司在徵實習生，看到職缺的條件這麼適合自己，就毫不猶豫地就投了履歷，覺得一定是這個工作在招喚我吧！（據說同事 Eddie 當時來面試也是這樣想的，如果你也突然有這種從天而降的自信，就快點投履歷吧哈哈）</p>
                <br/>
                <p>在公司最棒的就是可以直接參與一些很不錯的案子，直接從參與各個案子運作，學到一個專業的前端設計師應該具備的能力。能在短時間內，就接觸到這麼多知名大公司、各種類型的案子，對未來希望可以朝這個方向前進的實習生來說，真的是一個非常棒的實習機會！</p>
                <br/>
                <p>其實這個工作，也不是真的像大家想的一點缺點也沒有（臉色一沉）。</p>
                <p>立志成為福利最爽公司的 25sprout，讓我每次跟朋友聊到自己的工作，總是會不小心像直銷一樣表現得很熱愛自己的公司，還必須用意志力克制自己不要一再重複這些話，以免朋友覺得你是在炫耀，真的感到非常困擾。 25sprout 的實習生們還曾經因為福利太好，被新聞台採訪。希望你（妳）來之前也可以想一下，自己能不能承受這麼好的福利。</p>
                <br/>
                <p>如果你對前端開發有無限的熱情、希望能跟一群志同道合的同事一起上班、享受快樂的工作時間，</p>
                <p>快  點  寄  履  歷  吧！</p>`
    },
    {
        name: "EDDIE",
        position: "Front-End/ Back-End Developer",
        img: eddieIllustration,
        photo: eddiePhoto,
        article: `<p>
                     這麼說好了，<br/>
                     自從我加入新芽後，唯一不缺的就是別人對於我工作的訝異跟羨慕XD<br/>
                     在我的牆上完全可以看到我在新芽享受的各種好日子
                  </p>
                 <p>我們沒有死板板的辦公室沒有西裝領帶，只有從早到晚的 spotify、各種爽朗的笑聲以及 18歲以上的笑話，還有短褲跟拖鞋。</p>
                 <p>每天早上十點你可以再慢慢的拎著早餐走進辦公室，不過十點有可能還沒有人到，這時只好站在門外等一下XD，之後再悠閒地吃著早餐一邊工作，如果中午到了你肚子餓了，你可以在聊天室打「Hello~ everyone~ 我 2 2 der 」然後要等待有人附和你，因為我們會全公司一起去吃午餐～注意！這時候你不用帶錢包，因為我們洋派帥氣的老闆會帶 ( 我是認真的XD )</p>
                 <p>一起吃完午餐閒話家常之後，如果辦公室的零食衛生紙等等等用光了，大家就得再一起去個全聯 shopping 啦！下午回來也不必再買什麼咖啡了，因為就在去年尾牙本公司也進了一台「義大利 Saeco 全自動咖啡機」，自己的咖啡自己泡啦！<p/>
                 <p>晚上下班後你的聊天室還是會叫叫叫個不停，不過不會是工作的催促，大概會是在討論本季電影之夜到底要看復仇者聯盟還是玩命關頭呢？<br/>
                 以上，真的沒什麼，這不過是在 25sprout 的日常，很普通的。</p>
                 <p>嗯？我有提到每季會有一次全公司的「電影之夜」嗎？是不是也沒說到在家也可以工作的「remote work」？我的天....還有多少福利沒說完啊....
                 </p>`
    },
    {
        name: "ERIC",
        position: "Front-End/ Back-End Developer",
        img: ericIllustration,
        photo: ericPhoto,
        article: `<p>「欸，我在上班？」<br/>
                這大概是我來新芽實習的每一天都在腦中反覆出現的疑問句</p>

                <p>我是Eric，出生於傳統的商管學院<br/>
                四年教育表面上在研究模擬（幻想）一家企業的運籌帷幄<br/>
                實際上是在學習如何用西裝領帶將自己洗腦成一個肝很多、聽話的好職員</p>

                <p>結果來到新芽後，才發現根本學非所用lol</p>

                <p>這裡沒有主管與同事，只有充滿垃圾話與互相學習打氣的學長學姊們<br/>
                這裡沒有制服與隔間辦公桌，咖啡廳般的自在氛圍總讓你驚覺又要下班了<br/>
                這裡沒有煩雜的行政流程與文書往來，靈活彈性的步伐讓你的點子總是源源不絕</p>

                <p>大學時代沒有上過一堂資訊課的我，短短半年多，從前端設計到後台開發，從小型新創到知名企業，參與了十多個專案，且都扮演關鍵的角色，每一次都有許多意想不到的收穫</p>

                <p>如果你也像我一樣喜歡挑戰傳統四處冒險，又不喜歡每天洗襯衫領子<br/>
                Hey，別繼續在觀眾席裡坐著了，快下場一起成為25sprout的小夥伴吧！</p>`
    }
]



// WEBPACK FOOTER //
// ./src/models/Sprouters2014.js